export function LiantisLogo({ noText: _ = false }): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="90.7"
      height="34.9"
      viewBox="0 0 90.7 34.9"
      role="img"
    >
      <title>Liantis</title>
      <g fill="#7843a5">
        <path d="M67.7 26.9c-1.6 2.9-5.3 3.1-6.2 3.1H20c-3.6 0-5.3-1.6-6.1-3.1H8.3c1.2 3.9 4.7 7.9 11.7 7.9h41.5c4.2 0 10.2-2.2 11.8-7.9h-5.6zM5.5 24.2H0V.2h5.5v24zM7.8 3c0-1.7 1.4-3 3.1-3C12.6 0 14 1.3 14 3s-1.4 2.9-3.1 2.9C9.1 5.9 7.8 4.6 7.8 3zM8.1 7.8h5.4v16.3H8.1zM67.7 3c0-1.7 1.4-3 3.1-3 1.7 0 3.1 1.3 3.1 3s-1.4 2.9-3.1 2.9c-1.8 0-3.1-1.3-3.1-2.9zM68 7.8h5.4v16.3H68zM52.7 14.8v9.3h-5.4v-8.5c0-2.3-1.2-3.4-3-3.4-1 0-2 .5-3 1.6v10.3h-5.5V7.8h5.5v1.1c1.3-1 2.7-1.6 4.5-1.6 4.1 0 6.9 2.9 6.9 7.5zM79.8 18.6c.2 1.4 1.4 2.1 3.1 2.1 1.4 0 2.4-.4 2.4-1.1 0-.5-.5-1-1.6-1.1l-3.3-.6c-2.8-.5-4.8-2.1-4.8-4.9 0-3.4 3-5.5 7.3-5.5 3.5 0 7.4 1.3 7.6 5.7h-4.9c-.1-1.2-1.2-1.8-2.8-1.8-1.4 0-2.1.5-2.1 1.2 0 .5.4 1 1.7 1.3l3 .5c3.1.6 5.1 2.1 5.1 5 0 3.8-3.4 5.5-7.7 5.5-4.2 0-7.7-1.8-8-6.1l5-.2zM33.3 24.2h-5.4v-.9c-1.2.8-2.7 1.2-4.5 1.2-4.4 0-8.1-3.7-8.1-8.5 0-4.9 3.7-8.5 8.1-8.5 1.8 0 3.3.5 4.5 1.2v-.9h5.4v16.4zm-5.5-5.7v-5.1c-1-1.1-2.2-1.5-3.4-1.5-2.2 0-3.9 1.8-3.9 4.1s1.6 4 3.9 4c1.2 0 2.4-.3 3.4-1.5zM54.8 7.8V2.3h5.4v5.6h5.6v4.7h-5.6v4.7c0 1.7.9 2.5 2.6 2.5.8 0 1.7-.2 2.9-.4l.6 4.6c-2.1.7-3.3.8-4.9.8-3.9 0-6.6-2.9-6.6-7.3V7.8z"></path>
      </g>
    </svg>
  );
}
